import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RedemptionsComponent} from "@app/features/redemptions/redemptions/redemptions.component";
import {
  RedemptionDetailsComponent
} from "@app/features/redemptions/redemption-details/redemption-details.component";

const routes: Routes = [
  {
    path: '',
    component: RedemptionsComponent
  },
  {
    path: ':id',
    component: RedemptionDetailsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RedemptionsRoutingModule {
}
